import FileField from '@com/fields/FileField'
import FormMixin from '@com/mixins/form.mixin'

import { fileService } from '@api/file.service'
import { i18n } from '@js/i18n'

export default {
  mixins: [FormMixin],
  components: { FileField },
  props: ['schema', 'sale', 'token'],
  data: _ => ({
    i18n,
    form: {},
    documents: {}
  }),

  methods: {
    async uploadDocuments () {
      await Promise.all(Object.values(this.documents).map(document => uploadSingleDocument.apply(this, [document])))

      async function uploadSingleDocument (document) {
        if (!document || document.isUploaded) return
        this.documents[document.type] = await fileService.uploadSingleDocument(document)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/vue/app/saleCreation/steps/step.mixin.js